import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { LogOut, User as UserIcon } from "lucide-react";

const startGoogleLogin = () => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/dashboard";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <nav className="border-b border-[#E0DCD1] bg-[#F7F6F0]/80 backdrop-blur sticky top-0 z-40" data-testid="navbar">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-6 lg:px-12 py-5">
        <Link to="/" className="flex items-center gap-2" data-testid="navbar-brand">
          <span className="font-serif-display text-2xl tracking-tight">Holloway</span>
          <span className="font-mono-plex text-[10px] uppercase tracking-[0.2em] text-[#4B534E] border-l border-[#E0DCD1] pl-2 ml-1 hidden sm:block">
            Wealth Lab
          </span>
        </Link>

        <div className="flex items-center gap-3 sm:gap-6">
          <a href="#curriculum" className="hidden md:block text-sm text-[#4B534E] hover:text-[#1A3626] transition-colors" data-testid="nav-curriculum">Curriculum</a>
          <a href="#pricing" className="hidden md:block text-sm text-[#4B534E] hover:text-[#1A3626] transition-colors" data-testid="nav-pricing">Pricing</a>
          <a href="#faq" className="hidden md:block text-sm text-[#4B534E] hover:text-[#1A3626] transition-colors" data-testid="nav-faq">FAQ</a>

          {user ? (
            <div className="flex items-center gap-3">
              {user.is_admin && (
                <Link to="/admin" className="hidden md:inline-block text-xs font-mono-plex uppercase tracking-[0.18em] text-[#C56B52] hover:underline" data-testid="nav-admin">
                  Admin
                </Link>
              )}
              <Link to="/dashboard" className="flex items-center gap-2 text-sm text-[#1A3626] hover:underline" data-testid="nav-dashboard">
                {user.picture ? (
                  <img src={user.picture} alt="" className="w-7 h-7 rounded-full border border-[#E0DCD1]" />
                ) : (
                  <UserIcon size={16} />
                )}
                <span className="hidden sm:inline">{user.name?.split(" ")[0]}</span>
              </Link>
              <button onClick={handleLogout} className="text-[#4B534E] hover:text-[#1A3626]" data-testid="nav-logout" aria-label="Logout">
                <LogOut size={16} />
              </button>
            </div>
          ) : (
            <button onClick={startGoogleLogin} className="btn-primary text-sm py-2 px-4" data-testid="nav-signin">
              Sign in
            </button>
          )}
        </div>
      </div>
    </nav>
  );
}
